import { ICopySettingProps } from "./CopyItem.props";
import cn from "classnames";
import styles from "./CopyItem.module.scss";
import Copy from "@components/global/new/Copy/Copy";

export default function CopyItem({ ...props }: ICopySettingProps) {
  return (
    <div style={props.style} className={cn(styles.wrapper, props.className)}>
      {props.children}
      {props.text && (
        <Copy
          text={props.text}
          className={cn(styles.copy, props.copyClassName)}
        />
      )}
    </div>
  );
}
